import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NavigationBar.css';

interface NavigationBarProps {
  title: string;
}

const NavigationBar: React.FC<NavigationBarProps> = ({ title }) => {
  const navigate = useNavigate();

  return (
    <div className="navigation-bar">
      <button className="back-button" onClick={() => navigate('/')}>
        ← 返回
      </button>
      <h1 className="page-title">{title}</h1>
    </div>
  );
};

export default NavigationBar;
